import axios from "axios";
import moment from "moment/moment";
import store from "../../../store";

import {
  GET_SUBSCRIPTION_USER_SUCCESS,
  GET_SUBSCRIPTION_USER_FAILED,
  IS_LOADING_GET_SUBSCRIPTION_USER,
  CREATE_SUBSCRIPTION_USER_SUCCESS,
  CREATE_SUBSCRIPTION_USER_FAILED,
  IS_LOADING_CREATE_SUBSCRIPTION_USER,
  GET_SUBSCRIPTION_SUCCESS,
  GET_SUBSCRIPTION_FAILED,
  IS_LOADING_GET_SUBSCRIPTION,
  CREATE_SUBSCRIPTION_SUCCESS,
  CREATE_SUBSCRIPTION_FAILED,
  IS_LOADING_CREATE_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION_SUCCESS,
  UPDATE_SUBSCRIPTION_FAILED,
  IS_LOADING_UPDATE_SUBSCRIPTION,
  IS_LOADING_MAKE_HASH,
  MAKE_HASH_SUCCESS,
  MAKE_HASH_FAILED,
  ONE_TIME_PAYMENT_SUCCESS,
  ONE_TIME_PAYMENT_FAILED,
  IS_LOADING_ONE_TIME_PAYMENT,
  SUBSCRIPTION_PAYMENT_SUCCESS,
  SUBSCRIPTION_PAYMENT_FAILED,
  IS_LOADING_SUBSCRIPTION_PAYMENT,
  GET_ALL_SUBSCRIPTION_PLANS_SUCCESS,
  GET_ALL_SUBSCRIPTION_PLANS_FAILED,
  IS_LOADING_GET_ALL_SUBSCRIPTION_PLANS,
  CREATE_NEW_PAYMENT_HISTORY_SUCCESS,
  CREATE_NEW_PAYMENT_HISTORY_FAILED,
  IS_LOADING_CREATE_NEW_PAYMENT_HISTORY,
  GET_ALL_PAYMENT_HISTORY_OF_COMPANY_SUCCESS,
  GET_ALL_PAYMENT_HISTORY_OF_COMPANY_FAILED,
  IS_LOADING_GET_ALL_PAYMENT_HISTORY_OF_COMPANY,
} from "./types";

import Axios from "../../../common/util/Axios";

// environment variables
const PAY_HERE_URL = process.env.REACT_APP_PAY_HERE_BASE_URL;

// get subscription user
export const getSubscriptionUser = (companyId) => async (dispatch) => {
  try {
    dispatch({ type: IS_LOADING_GET_SUBSCRIPTION_USER, payload: true });

    console.log(`ENV CHECK: /api/dashboard/subscription-management/users`);

    const res = await Axios.get(`/api/dashboard/subscription-management/users`, {
      params: {
        companyId: companyId,
      },
    });


    dispatch({
      type: GET_SUBSCRIPTION_USER_SUCCESS,
      payload: res.data.data,
    });

    dispatch({ type: IS_LOADING_GET_SUBSCRIPTION_USER, payload: false });
  } catch (err) {
    dispatch({
      type: GET_SUBSCRIPTION_USER_FAILED,
    });
    dispatch({ type: IS_LOADING_GET_SUBSCRIPTION_USER, payload: false });
    console.log(err);
  }
};

// create subscription user
export const createSubscriptionUser = (details) => async (dispatch) => {
  try {
    
    dispatch({
      type: IS_LOADING_CREATE_SUBSCRIPTION_USER,
      payload: true,
    });

    const reqBody = {
      id: details.id,
      companyId: details.companyId,
      firstName: details.firstName,
      lastName: details.lastName,
      email: details.email,
      phone: details.phone,
      address: details.address,
      city: details.city,
    };


    const res = await Axios.post(
      `/api/dashboard/subscription-management/users`,
      reqBody
    );
    
    if (res.data.success) {
      dispatch({
        type: CREATE_SUBSCRIPTION_USER_SUCCESS,
        payload: res.data.data,
      });

      dispatch({
        type: IS_LOADING_CREATE_SUBSCRIPTION_USER,
        payload: false,
      });
    } else {
      dispatch({
        type: CREATE_SUBSCRIPTION_USER_FAILED,
        payload: res.data.error,
      });
      dispatch({
        type: IS_LOADING_CREATE_SUBSCRIPTION_USER,
        payload: false,
      });
    }
  } catch (err) {
    dispatch({
      type: CREATE_SUBSCRIPTION_USER_FAILED,
      payload: err.response.data.error,
    });
    dispatch({
      type: IS_LOADING_CREATE_SUBSCRIPTION_USER,
      payload: false,
    });
  }
};

// get subscription
export const getSubscriptionDetails = (details) => async (dispatch) => {

  try {

    const res = await Axios.get(
      `/api/dashboard/subscription-management/subscriptions`,
      {
        params: {
          companyId: details.companyId,
          serviceId: details.serviceId,
        },
      }
    );


    dispatch({
      type: GET_SUBSCRIPTION_SUCCESS,
      payload: res.data.data,
    });

    dispatch({ type: IS_LOADING_GET_SUBSCRIPTION, payload: false });
  } catch (err) {
    dispatch({
      type: GET_SUBSCRIPTION_FAILED,
    });
    dispatch({ type: IS_LOADING_GET_SUBSCRIPTION, payload: false });
    console.log(err);
  }
};

// create subscription
export const createSubscription = (details) => async (dispatch) => {
  try {
    dispatch({
      type: IS_LOADING_CREATE_SUBSCRIPTION,
      payload: true,
    });

    const reqBody = {
      serviceId: details.serviceId,
      subscriptionPlanId: details.subscriptionPlanId,
      companyId: details.companyId,
    };


    const res = await Axios.post(
      `/api/dashboard/subscription-management/subscriptions`,
      reqBody
    );


    if (res.data.success) {
      dispatch({
        type: CREATE_SUBSCRIPTION_SUCCESS,
        payload: res.data.data,
      });

      dispatch({
        type: IS_LOADING_CREATE_SUBSCRIPTION,
        payload: false,
      });
    } else {
      dispatch({
        type: CREATE_SUBSCRIPTION_FAILED,
        payload: res.data.error,
      });
      dispatch({
        type: IS_LOADING_CREATE_SUBSCRIPTION,
        payload: false,
      });
    }
  } catch (err) {
    dispatch({
      type: CREATE_SUBSCRIPTION_FAILED,
      payload: err.response.data.error,
    });
    dispatch({
      type: IS_LOADING_CREATE_SUBSCRIPTION,
      payload: false,
    });
  }
};

// create subscription
export const updateSubscription = (subscriptionId) => async (dispatch) => {
  try { 

    const reqBody = {
     isRecurring: true,
     id: subscriptionId
    };

    const res = await Axios.put(
      `/api/dashboard/subscription-management/subscriptions`,
      reqBody
    );


    if (res.data.success) {
      dispatch({
        type: UPDATE_SUBSCRIPTION_SUCCESS,
        payload: res.data.data,
      });

    } else {
      dispatch({
        type: UPDATE_SUBSCRIPTION_FAILED,
        payload: res.data.error,
      });
    }
  } catch (err) {
    dispatch({
      type: UPDATE_SUBSCRIPTION_FAILED,
      payload: err.response.data.error,
    });
    dispatch({
      type: IS_LOADING_UPDATE_SUBSCRIPTION,
      payload: false,
    });
  }
};

// making payment hash
export const makePaymentHash = (paymentDetails) => async (dispatch) => {
  try {
    dispatch({ type: IS_LOADING_MAKE_HASH, payload: true });

    const res = await Axios.post(
      `/api/dashboard/subscription-management/generate-hash`,
      paymentDetails
    );

    const hash = res.data.data.hash;


    dispatch({
      type: MAKE_HASH_SUCCESS,
      payload: hash,
    });

    return hash; // Return the hash to the caller
  } catch (error) {
    dispatch({
      type: MAKE_HASH_FAILED,
      payload: error.response ? error.response.data : "Error generating hash",
    });
    throw error; // Throw the error to be handled by the caller if needed
  } finally {
    dispatch({ type: IS_LOADING_MAKE_HASH, payload: false });
  }
};

// one time payment
export const oneTimePayment = (paymentData) => async (dispatch) => {
  try {
    dispatch({ type: IS_LOADING_ONE_TIME_PAYMENT, payload: true });

    const res = await axios.post(`${PAY_HERE_URL}`, paymentData);

    dispatch({
      type: ONE_TIME_PAYMENT_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: ONE_TIME_PAYMENT_FAILED,
      payload: error.response
        ? error.response.data
        : "Error processing one-time payment",
    });
  } finally {
    dispatch({ type: IS_LOADING_ONE_TIME_PAYMENT, payload: false });
  }
};

// subscription payment
export const subscriptionPayment = (paymentData) => async (dispatch) => {
  try {
    dispatch({ type: IS_LOADING_SUBSCRIPTION_PAYMENT, payload: true });

    const res = await axios.post(`${PAY_HERE_URL}`, paymentData);

    dispatch({
      type: SUBSCRIPTION_PAYMENT_SUCCESS,
      payload: res.data,
    });
  } catch (error) {
    dispatch({
      type: SUBSCRIPTION_PAYMENT_FAILED,
      payload: error.response
        ? error.response.data
        : "Error processing subscription payment",
    });
  } finally {
    dispatch({ type: IS_LOADING_SUBSCRIPTION_PAYMENT, payload: false });
  }
};

// get all subscription plans
export const getAllSubscriptionPlans = (serviceId) => async (dispatch) => {
  dispatch({ type: IS_LOADING_GET_ALL_SUBSCRIPTION_PLANS, payload: true });
  try {
    const res = await Axios.get(
      `/api/dashboard/subscription-management/subscription-plans?serviceId=${serviceId}`
    );

    dispatch({
      type: GET_ALL_SUBSCRIPTION_PLANS_SUCCESS,
      payload: res.data.data,
    });

    dispatch({ type: IS_LOADING_GET_ALL_SUBSCRIPTION_PLANS, payload: false });
  } catch (err) {
    dispatch({
      type: GET_ALL_SUBSCRIPTION_PLANS_FAILED,
    });
    dispatch({ type: IS_LOADING_GET_ALL_SUBSCRIPTION_PLANS, payload: false });
    console.log(err);
  }
};

// create new payment history
export const createNewPaymentHistory = (details) => async (dispatch) => {
  try {
    dispatch({
      type: IS_LOADING_CREATE_NEW_PAYMENT_HISTORY,
      payload: true,
    });

    const reqBody = {
      userId: details.userId,
      subscriptionId: details.subscriptionId,
      orderId: details.orderId,
      paymentId: details.paymentId,
      companyId: details.companyId,
      serviceId: details.serviceId,
      status: details.status,
      amount: details.amount,
    };


    const res = await Axios.post(
      `/api/dashboard/subscription-management/payment-history`,
      reqBody
    );

    console.log(details.orderId);

    if (res.data.success) {
      dispatch({
        type: CREATE_NEW_PAYMENT_HISTORY_SUCCESS,
        payload: res.data.data,
      });
      dispatch({
        type: IS_LOADING_CREATE_NEW_PAYMENT_HISTORY,
        payload: false,
      });
    } else {
      dispatch({
        type: CREATE_NEW_PAYMENT_HISTORY_FAILED,
      });
    }
    dispatch({
      type: IS_LOADING_CREATE_NEW_PAYMENT_HISTORY,
      payload: false,
    });
  } catch (err) {
    dispatch({
      type: CREATE_NEW_PAYMENT_HISTORY_FAILED,
    });
    dispatch({
      type: IS_LOADING_CREATE_NEW_PAYMENT_HISTORY,
      payload: false,
    });
  }
};

// get all payment history for company
export const getAllPaymentHistoryforCompany =
  (companyId) => async (dispatch) => {
    
    dispatch({
      type: IS_LOADING_GET_ALL_PAYMENT_HISTORY_OF_COMPANY,
      payload: true,
    });

    try {
      const res = await Axios.get(
        `/api/dashboard/subscription-management/payment-history?companyId=${companyId}`
      );

      dispatch({
        type: GET_ALL_PAYMENT_HISTORY_OF_COMPANY_SUCCESS,
        payload: res.data.data,
      });
      dispatch({
        type: IS_LOADING_GET_ALL_PAYMENT_HISTORY_OF_COMPANY,
        payload: false,
      });
    } catch (err) {
      dispatch({
        type: GET_ALL_PAYMENT_HISTORY_OF_COMPANY_FAILED,
      });
      dispatch({
        type: IS_LOADING_GET_ALL_PAYMENT_HISTORY_OF_COMPANY,
        payload: false,
      });
      console.log(err);
    }
  };

// updaten subscription to another

export const updateSubscriptiontoAnother = (details) => async (dispatch) => {
  try {
  
    const reqBody = {
      service_id: details.service_id,
      subscription_plan_id: details.subscription_plan_id,
      company_id: details.company_id,
      user_id: details.user_id,
    };

    const res = await Axios.put(
      `/api/dashboard/subscription-management/subscriptions`,
      reqBody
    );

    if (res.data.success) {
      dispatch({
        type: UPDATE_SUBSCRIPTION_SUCCESS,
        payload: res.data.data,
      });
    } else {
      dispatch({
        type: UPDATE_SUBSCRIPTION_FAILED,
      });
    }
  } catch (err) {
    dispatch({
      type: UPDATE_SUBSCRIPTION_FAILED,
    });
  }
};
